export const linkUrl = "https://tour.voyageride.com/api";
